/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-27 15:22:56
 * @LastEditTime: 2025-08-18 11:43:48
 */
/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-03-27 15:20:08
 */
import React, { useState, useEffect} from "react";
import { Input, Select, Pagination, message } from 'antd';
import { useParams, useNavigate } from "react-router-dom";
import OrderTableMain from "../components/order-table";
import { orderStatusArr, titleList, timeList } from './config';
import { getOrderList, orderCountTotal } from '@/api/personal-center';
import NoData from '@/components/no-data';
import useBackToTop from '@/hooks/useBackToTop';
import searchImg from '../assets/search.png';
import './index.scss';

const MyOrderList: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { scrollToTop } = useBackToTop(300); // 调用自定义 Hook
  const [searchValue, setSearchValue] = useState('');
  const [orderValue, setOrderValue] = useState(Number(params.id??'-1')); // 订单状态，-1全部
  const [orderData, setOrderData] = useState([]);
  const [pageNum, setPageNum] = useState(1); // 表格页码
  const [pageSize, setPageSize] = useState(10); // 表格页长
  const [isRefresh, setIsRefresh] = useState(false); // 更新列表
  const [dateType, setDateType] = useState<number | string>(""); // 时间段
  const [payType, setPayType] = useState(0); // 支付方式
  const [total, setTotal] = useState<number>();
  const [orderStatus, setOrderStatus] = useState<any>(orderStatusArr); // 订单状态统计数据
  useEffect(() => {
    orderListFunc();
  },[orderValue,dateType,payType,pageNum])

  useEffect(() => {
    if(isRefresh) {
      orderListFunc();
      orderCountFunc();
    }
  },[isRefresh])

  useEffect(() => {
    orderCountFunc();
  },[orderValue]);

  const orderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
  };
  // 订单状态统计
  const orderCountFunc = () => {
    orderCountTotal().then((oData:any) => {
      if(oData.success) {
        const getObj = oData.obj;
        const getStatus = [...orderStatus];
        getStatus[0].count = getObj.unpaid;
        getStatus[1].count = getObj.audit;
        getStatus[2].count = getObj.unReceive;
        setOrderStatus(getStatus);
      }
    })
  }

  // 搜索
  const orderSearch = () => {
    orderListFunc()
  }
  // 订单状态切换
  const statusTabSelect = (value:number) => {
    setOrderValue(value);
    setPageNum(1);
    navigate(`/user/orderList/${value}`);
  }
  const handleChangePagination = (page: number, pageSize: number) => {
    setPageNum(page);
    setPageSize(pageSize);
    scrollToTop();
  };
  // 获取订单列表
  const orderListFunc = () => {
    let status = null;
    setOrderData([]);
    if(orderValue !== -1) {
      status = orderValue;
    }
    const params:any = {status,pageNum,pageSize,dateType};
    if(orderValue === 6) {
      params.payStatus = 3;
    }
    if(searchValue !== '') {
      params.orderName = searchValue;
    }
    if(payType !== 0){
      params.payType = payType;
    }
    getOrderList(params).then((gRes:any) => {
      if(gRes.success) {
        setOrderData(gRes.obj.list);
        setTotal(gRes.obj.total);
        if(pageNum>0 && gRes.obj.list.length === 0 && gRes.obj.total > 0) {
          setPageNum(pageNum-1);
        }
      }else {
        message.error(gRes.message);
      }
    })
  }
  // 支付方式切换
  const paySelectFunc = (value:number) => {
    setPageNum(1);
    setPayType(value);
  }
  // 时间段切换
  const timeSelectFunc = (value:number | string) => {
    setPageNum(1);
    setDateType(value);
  }
  return (
    <div className="my-order-list">
      <div className="order-head">
        我的订单
        <div className="search-input">
          <Input placeholder="商品名称" onChange={orderChange} onPressEnter={orderSearch} />
          <span onClick={()=>orderSearch()}><img src={searchImg} alt='' /></span>
        </div>
      </div>
      <div className="order-list-content">
        <ul className="status-tab">
          <li className={`${orderValue === -1 && 'select'}`} onClick={()=>statusTabSelect(-1)}>全部</li>
          {
            orderStatusArr.map((oData) => (
              <li 
                key={oData.value} 
                className={`${orderValue === oData.value && 'select'}`} 
                onClick={()=>statusTabSelect(oData.value)}
              >
                {oData.label}
                {
                  (oData.count && oData.count > 0) ?
                  <i>{oData.count > 9? '9+': oData.count}</i>:''
                }
              </li>
            ))
          }
          <Select 
            placeholder='全部'
            options={timeList}
            onChange={timeSelectFunc}
            popupMatchSelectWidth={150}
            getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
          />
        </ul>
        
        <div className="list-header">
          {
            titleList.map((tData,index) => (
              <div key={index} style={{width: tData.width}} className="list-header-title">
                {
                  tData.list ?
                  <Select
                    style={{ width: tData.width }}
                    placeholder={tData.name}
                    onChange={paySelectFunc}
                    options={tData.list}
                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
                  />:
                  <>{tData.name}</>
                }
              </div>
            ))
          }
        </div>
        {
          orderData.length > 0?
          <>
            <OrderTableMain orderData={orderData} setIsRefresh={setIsRefresh} />
            <div className="page-bottom">
              <Pagination
                current={pageNum}
                pageSize={pageSize}
                total={total}
                onChange={(page, pageSize) =>
                  handleChangePagination(page, pageSize)
                }
                showQuickJumper
                showSizeChanger={false}
              />
            </div>
          </>
          :
          <NoData title='暂无数据' />
        }
      </div>
    </div>
  )
}

export default MyOrderList;